import { render, staticRenderFns } from "./ReservationColumnNew.vue?vue&type=template&id=e5cd49c6&scoped=true&"
import script from "./ReservationColumnNew.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnNew.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnNew.vue?vue&type=style&index=0&id=e5cd49c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd49c6",
  null
  
)

export default component.exports